<template>
  <v-btn
    :ripple="false"
    :class="$style.smallBtn"
    data-testid="smallBtn"
    size="x-small"
    height="auto"
    variant="flat"
  >
    <slot>Button</slot>
  </v-btn>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.smallBtn {
  padding: 3px 8px;
  min-width: 58px;
  margin-top: -1px;
  background-color: colors.$color-gray-200;
  text-transform: none;
  letter-spacing: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 18.75px;
  transition-property: none;

  :global {
    .v-btn__overlay {
      display: none;
    }
    .v-btn__content {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 1px;
      color: colors.$color-brand-800;
    }
  }

  &:hover {
    background-color: colors.$color-gray-100;
  }

  &:active {
    background-color: colors.$color-gray-50;
  }

  &:disabled {
    background-color: colors.$color-gray-200;

    :global {
      .v-btn__content {
        color: colors.$color-text-tertiary;
      }
    }
  }
}
</style>
